import { download, downloadBySid, GetFileInfoByFileId, GetFileInfoBySid } from '@/services/api'
import { isSpecialFrame } from '@/utils/tools.js'
import DownloadCommand from '@/utils/command/download'

type fileInfoType = {
  groupId: number | string
  fileId: number | string
  [key: string]: any
}

export const downloadFile = async (fileInfo: fileInfoType, { sid = 0, userInfo = null }: {
  sid?: number
  userInfo?: null | Record<string, any>
} = {}) => {
  if (!fileInfo) return
  let downloadAdapter!: Promise<any>
  if (userInfo) {
    downloadAdapter = download(fileInfo.groupId, fileInfo.fileId)
  } else if (sid) {
    downloadAdapter = downloadBySid(sid)
  } else {
    downloadAdapter = download(fileInfo.groupId, fileInfo.fileId)
  }
  const res = await downloadAdapter
  const command = new DownloadCommand(res.fileinfo.url, {
    groupid: fileInfo.groupId,
    fileid: fileInfo.fileId
  })
  command.execute()
}

export const fetchFileInfo = async ({
  fileId = 0,
  sId = 0
}: {
  fileId?: string | number,
  sId?: string | number
}) => {
  if (!fileId && !sId) return null
  let fileInfo
  if (fileId) {
    fileInfo = await GetFileInfoByFileId(fileId)
  } else if (sId) {
    fileInfo = await GetFileInfoBySid(sId)
  }
  return fileInfo
}
